import React, { useState } from "react";
import { Global } from "../helpers/Global";

export const CambiarContrasena = () => {
    const [actualPassword, setActualPassword] = useState("");
    const [nuevaPassword, setNuevaPassword] = useState("");
    const [confirmarPassword, setConfirmarPassword] = useState("");
    const [mensaje, setMensaje] = useState("");

    const handleChangePassword = async (e) => {
        e.preventDefault();

        if (!actualPassword || !nuevaPassword || !confirmarPassword) {
            setMensaje("Todos los campos son obligatorios.");
            return;
        }

        if (nuevaPassword.length < 8) {
            setMensaje("La nueva contraseña debe tener al menos 8 caracteres.");
            return;
        }

        if (nuevaPassword !== confirmarPassword) {
            setMensaje("Las nuevas contraseñas no coinciden.");
            return;
        }

        try {
            const response = await fetch(`${Global.url}usuarios/cambiar-contrasena`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({ actualPassword, nuevaPassword, confirmarPassword }),
            });

            const data = await response.json();
            setMensaje(data.message);

            if (response.ok) {
                setActualPassword("");
                setNuevaPassword("");
                setConfirmarPassword("");
            }
        } catch (error) {
            console.error("Error al cambiar la contraseña:", error);
            setMensaje("Error en la conexión con el servidor.");
        }
    };

    return (
        <div className="ajustes">
            <h2 >Cambiar Contraseña</h2>
            <div className="cambiar-contrasena">

                {mensaje && <p className="rojo">{mensaje}</p>}

                <form onSubmit={handleChangePassword}>
                    <div className="form-group">
                        <label>Contraseña Actual:</label>
                        <input
                            type="password"
                            value={actualPassword}
                            onChange={(e) => setActualPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Nueva Contraseña:</label>
                        <input
                            type="password"
                            value={nuevaPassword}
                            onChange={(e) => setNuevaPassword(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Confirmar Nueva Contraseña:</label>
                        <input
                            type="password"
                            value={confirmarPassword}
                            onChange={(e) => setConfirmarPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn-login">Actualizar Contraseña</button>
                </form>
            </div>
        </div>
    );
};
